import {Component, DestroyRef, inject, OnInit} from '@angular/core';
import {TopBarComponent} from '../top-bar/top-bar.component';
import {TripCardComponent} from '../trip-card/trip-card.component';
import {SharedDataService} from '../../services/shared-data.service';
import {AsyncPipe} from '@angular/common';
import {MatIcon} from '@angular/material/icon';
import {map, tap} from 'rxjs';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {SupportApiService} from '../../services/support-api.service';
import {SessionStorageService} from 'ngx-webstorage';
import {DriverReq, PassengerRequest} from '../../interfaces/miranda.interface';
import {Router} from '@angular/router';
import {MirandaApiService} from '../../services/miranda-api.service';

@Component({
  selector: 'app-trip-details',
  imports: [
    TopBarComponent,
    TripCardComponent,
    AsyncPipe,
    MatIcon
  ],
  templateUrl: './trip-details.component.html',
  styleUrl: './trip-details.component.scss'
})
export class TripDetailsComponent implements OnInit{

  private supportApiService: SupportApiService = inject(SupportApiService);
  private mirandaApiService: MirandaApiService = inject(MirandaApiService);
  private router: Router = inject(Router);
  private destroyRef: DestroyRef = inject(DestroyRef);
  private sessionStorageService: SessionStorageService = inject(SessionStorageService);
  public userType: 'passenger' | 'driver' = this.sessionStorageService.retrieve('userType');
  public order: PassengerRequest | DriverReq | null = null;
  public passengerReq: PassengerRequest = this.sessionStorageService.retrieve('trip');
  public driverReq: DriverReq = this.sessionStorageService.retrieve('trip');
  public isOderId = false
  public departments$ = this.supportApiService.getDepartments()
    .pipe(
      map(data => {
        return data?.data;
      }),
      takeUntilDestroyed()
    );

  navigateToDepartment(department_uuid: string, display_name: string) {
    this.router.navigate([`/departments`], {queryParams: {
        display_name,
        department_uuid,
        request_id: this.order ? this.order.id : this.userType === 'passenger' ? this.passengerReq.id : (this.driverReq?.request_id || this.driverReq?.id)
    }});
  }

  ngOnInit(): void {
    const orderId = this.sessionStorageService.retrieve('order_id');
    this.isOderId = !!orderId;
    const serviceId = this.sessionStorageService.retrieve('service');
    if(orderId) {
      if(this.userType === 'driver') {
        this.mirandaApiService.getDriverReqOne(orderId)
          .pipe(
            map(result => result.data),
            tap((result) => this.driverReq = result),
            takeUntilDestroyed(this.destroyRef)
          )
          .subscribe();
      } else {
        this.mirandaApiService.getPassengerReqOne(orderId, serviceId)
          .pipe(
            map(result => result.data),
            tap((result) => this.passengerReq = result),
            takeUntilDestroyed(this.destroyRef)
          )
          .subscribe();
      }
    }
  }
}
